import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    width: "100%",
  },
  upperContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "24px",
    marginTop: 16,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 24,
      gridTemplateColumns: "none",
    },
  },
  bottomContainer: {
    marginTop: 46,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 6,
    },
  },
  bottomFormContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gridGap: "24px",
    marginTop: 16,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 24,
      gridTemplateColumns: "none",
    },
  },
  input: {
    display: "grid",
    marginTop: 26,
  },
  link: {
    display: "block",
    marginTop: 32,
    textDecoration: "underline",
    cursor: "pointer",
    padding: "0px 2px",
  },
  termsBox: {
    display: "flex",
    justifyContent: "flex-start",
    alignitems: "center",
    marginTop: 40,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 28,
    },
  },
  checkboxContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    marginRight: 12,
    transform: "translateY(-3px)",
  },
  note: {
    display: "block",
    marginTop: 20,
    [theme.breakpoints.down("desktop")]: {
      fontSize: theme.fontSizes.md,
      marginTop: 8,
    },
  },

  terms: {
    marginTop: 50,
    display: "flex",
    justifyContent: "flex-start",
  },

  buttonContainer: {
    marginTop: 40,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 53,
    },
  },
  clickableSpan: {
    cursor: "pointer",
    textDecoration: "underline",
  },
  nextButton: {
    marginTop: 40,
    marginBottom: 20,
  },
  message: {
    marginTop: 24,
    [theme.breakpoints.down("desktop")]: {
      marginTop: 28,
    },
  },
  resend: {
    display: "block",
    textDecoration: "underline",
    marginTop: 8,
  },
  loaderContainer: {
    width: "100%",
  },
  termsAndPrivacy_container: {},

  checkBoxError: {
    marginTop: "2px",
    fontSize: "14px",
    color: "#BD0202",
  },
}));

export default useStyles;
